import { createSlice } from "@reduxjs/toolkit";
import { ORG_KYC_USERS_LIST_STATE } from "../../state";

const initialState = {
  ...ORG_KYC_USERS_LIST_STATE,
};

const orgKycUsersSlice = createSlice({
  name: "ORG_KYC_USERS_SLICE",
  initialState,
  reducers: {
    startOrgKycUsersList: (state) => {
      state.orgKycUsersListLoading = true;
      state.orgKycUsersListError = null;
    },
    successOrgKycUsersList: (state, action) => {
      state.orgKycUsersListLoading = false;
      state.orgKycUsersList = action.payload.list;
      state.orgKycUsersTotal = action.payload.total;
    },
    errorOrgKycUsersList: (state, action) => {
      state.orgKycUsersListLoading = false;
      state.orgKycUsersListError = action.payload;
    },
  },
});

export const {
  startOrgKycUsersList,
  successOrgKycUsersList,
  errorOrgKycUsersList,
} = orgKycUsersSlice.actions;

export default orgKycUsersSlice.reducer;
